import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useEffect } from "react";

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
	  //console.log(user);
	  if(user.role === "Admin_Sales" || user.role === "Sales") 
		navigate("/dashboard-sales");
	  else if(user.role === "Admin") 
		navigate("/dashboard-transaction");
    }
  }, [user, navigate]);

  const handleSubmit = async (e: any) => {
	  e.preventDefault();

	  // Basic regex sanitasi
	  const unsafePattern = /[;'"\-\\]/;
	  const isValidUsername = /^[a-zA-Z0-9._-]{3,30}$/.test(username);
	  const isValidPassword = password.length >= 4;

	  if (unsafePattern.test(username) || unsafePattern.test(password)) {
		alert("Input mengandung karakter tidak valid.");
		return;
	  }

	  if (!isValidUsername) {
		alert("Username hanya boleh huruf, angka, titik, underscore, atau strip. Panjang 3-30 karakter.");
		return;
	  }

	  if (!isValidPassword) {
		alert("Password minimal 6 karakter.");
		return;
	  }

	  setLoading(true);
	  try {
		await login(username, password);
		//console.log(user);
		//navigate("/dashboard");
	  } catch (err) {
		alert("Login gagal");
		setLoading(false);
	  }
	};


  return (
    <div className="flex items-center justify-center h-screen bg-cover bg-center" style={{ backgroundImage: "url('/bg-warehouse.jpg')" }}>
      <form onSubmit={handleSubmit} className="bg-white p-8 shadow-md rounded w-96 opacity-95">
        <img src="/logo-stardia-wns.jpg" alt="Stardia WMS" className="mx-auto mb-4 h-12" />
        <h2 className="text-base mb-4 font-bold text-center">Login WMS</h2>
        
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Username"
          className="w-full p-2 mb-4 border rounded text-[13px]"
		  autoComplete="off"
          required
        />

        <div className="relative mb-4">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full p-2 border rounded pr-10 text-[13px]"
			autoComplete="off"
            required
          />
          <span
            className="absolute right-3 top-2 cursor-pointer text-gray-500"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white p-2 w-full rounded disabled:opacity-50 text-base"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
